module.exports = __webpack_public_path__ + "media/summer_2023_sweepstakes/your-future-is-now-landing-lock-up-7a62ee52.png";